import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NVD3Chart from 'react-nvd3';
import metricsTools from '../../utils/metricsTools';
import hideNVD3Tooltip from '../../utils/hideNVD3Tooltip';

const formatDataForChart = data => {
    const res = [];

    for (let i = 0; i < data.length; i = i + 1) {
        if (data[i].storageUtilized > 0) {
            res.push({
                key: data[i].bucketName,
                value: data[i].storageUtilized,
            });
        }
    }
    return res;
};

const context = {
    valueFormatter: d => metricsTools.bytesToSize(d),
    contentGenerator: d =>
        `<table>
          <tbody>
            <tr>
              <td class="legend-color-guide">
                <div style="background-color: ${d.color};"></div>
              </td>
              <td class="key">${d.data.key}</td>
              <td class="value">${(d.percent * 100).toFixed(0)}%</td>
              <td>(${metricsTools.bytesToSize(d.data.value)})</td>
            </tr>
          </tbody>
        </table>`,
};

class BucketStoragePieChartComponent extends Component {
    componentWillReceiveProps() {
        hideNVD3Tooltip();
    }

    render() {
        return (
          <div>
            <NVD3Chart
              id="pieChart"
              type="pieChart"
              context={context}
              title={this.props.title}
              datum={formatDataForChart(this.props.data)}
              margin={{}}
              x={ d => (d.key)}
              y={ d => (d.value)}
              showLabels={this.props.labels}
              showLegend={this.props.legend}
              showTooltipPercent={true}
              donut={this.props.donut}
              height={this.props.height || 400}
              tooltip={{
                  valueFormatter: {
                      name: 'valueFormatter',
                      type: 'function',
                  },
                  contentGenerator: {
                      name: 'contentGenerator',
                      type: 'function',
                  },
              }}
            />
          </div>
        );
    }
}

BucketStoragePieChartComponent.propTypes = {
    legend: PropTypes.bool,
    donut: PropTypes.bool,
    labels: PropTypes.bool,
    data: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    height: PropTypes.number,
};

export default BucketStoragePieChartComponent;



/** WEBPACK FOOTER **
 ** ./src/components/charts/BucketStoragePieChartComponent.js
 **/